export default __webpack_public_path__ + "static/media/EstefaniRuiz.e2ba32f4.png";